import request from 'lib/request';

export interface Response {
  code: number;
  data: SocialParticipate;
  msg: string;
}

export interface SocialParticipate {
  fail_msg: string;
  /**
   * 当 为 false 表示社媒账号已经参与过 raffle, 并且会有失败信息。
   */
  success: boolean;
}

export async function raffleEntrySocialParticipate(raffle_id: number) {
  const res = await request<Response>('/raffle_entry/social_participate', {
    params: {
      raffle_id,
    },
  });
  return res?.data;
}
